import React from "react";
import Loadable from "react-loadable";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { UserContextSelectors } from "../../../redux/selectors";
import { EmptyComponent } from "../EmptyComponent";

export const ChecklistPC = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "checklist/pc/checklist" */

      "./Checklist.pc"
    ),
  render(loaded, props) {
    let Component = loaded.ChecklistPC;
    return <Component {...props} />;
  },
  loading: EmptyComponent
});

export const ChecklistMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "checklist/mobile/checklist" */

      "./Checklist.mobile"
    ),
  render(loaded, props) {
    let Component = loaded.ChecklistMobile;
    return <Component {...props} />;
  },
  loading: EmptyComponent
});

const ChecklistComponent = ({ title, items, onClick }) => {
  const isMobile = useSelector(UserContextSelectors.isMobile);

  return isMobile ? (
    <ChecklistMobile title={title} items={items} onClick={onClick} />
  ) : (
    <ChecklistPC title={title} items={items} onClick={onClick} />
  );
};

export default ChecklistComponent;

ChecklistComponent.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  onClick: PropTypes.func
};
